import { Navigate, Outlet } from "react-router-dom";
import authService from "../redux/auth/authService";
import { getAdminHomeRoute } from "../constants/adminAccess";

const isAuthenticated = () => {
  return localStorage.getItem("accessToken");
};

const PublicRoute = () => {
  const userType = localStorage.getItem("userType");
  return isAuthenticated() ? (
    userType !== "4" ? (
      <Navigate to="/dashboard" />
    ) : (
      <Navigate to={getAdminHomeRoute(authService.getAumUserId())} />
    )
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
